/**
 * Component: InvertNavigation
 * -----------------------------------------------------------------------------
 * Sets variables to control navigation background color.
 *
 */

/**
 * Var names.
 */
const BG_COLOR_KEY = '--header-bg-color'
const COLOR_KEY = '--header-color'
const BOX_SHADOW_KEY = '--header-box-shadow'

/**
 * DOM selectors.
 */
const selectors = {
  invertingSections: '.js-invert-navigation',
  darkText: 'js-dark-text',
  root: ':root',
}

/**
 * Create a new example object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    invertingSections: document.querySelectorAll(selectors.invertingSections),
    root: document.querySelector(selectors.root),
  }

  /**
   * Handle intersection
   */
  const handleIntersection = (entries) => {
    if (!nodeSelectors.root) {
      return
    }
    const { style } = nodeSelectors.root

    entries.forEach(entry => {

      const isDark = entry.target?.classList?.contains(selectors.darkText)

      if (entry.isIntersecting) {
        // Element has entered the viewport
        style.setProperty(BG_COLOR_KEY, 'transparent')
        if (!isDark) {
          style.setProperty(COLOR_KEY, 'var(--header-color-light)')
        }
        style.setProperty(BOX_SHADOW_KEY, 'var(--header-box-shadow-light)')

        return
      }

      // Element has exited the viewport
      style.setProperty(BG_COLOR_KEY, 'var(--header-bg-color-light)')
      style.setProperty(COLOR_KEY, 'var(--header-color-dark)')
      style.setProperty(BOX_SHADOW_KEY, 'var(--header-box-shadow-dark)')
    })
  }

  /**
   * Initialise component.
   */
  function init() {
    const observer = new IntersectionObserver(handleIntersection)
    for (const $el of nodeSelectors.invertingSections) {
      observer.observe($el, {
        threshold: 0.1,
      })
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
